import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

/**
 * the number in the style name indicates the start column and span of the item on desktop
 * for example, ImageItemStyle23 means the item starts at column 2 and spans 3 columns on desktop
 */

export const ImageItem23 = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'none',
  '& > img': {
    width: '100%'
  },
  [theme.breakpoints.up('md')]: {
    display: 'block',
    gridColumn: '1 / span 4'
  },
  [theme.breakpoints.up('lg')]: {
    display: 'block',
    gridColumn: '2 / span 3'
  }
}));
